import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-end;
    justify-content: flex-start;
    /* padding-inline: 25px; */
    width: 100%;
`;

export const ReadOnlyValue = styled.span`
    color: #333;
    text-align: right;
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: 116.508%;
    @media (orientation: landscape) and (max-width: 1200px) {
        font-size: 25px;
        line-height: normal;
    }
`;

export const InputUnit = styled.span`
    color: #333;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%;
    max-width: 100px;
    text-align: right;
    @media (orientation: landscape) and (max-width: 1200px) {       
        font-size: 14px;
    }
`;

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    position: absolute;
    top: 0;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};
`;

export const ContainerSP = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    position: absolute;
    top: 75%;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};
`

export const ContainerState = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 58%;
    align-items: center;
    justify-content: flex-end;
    height: 20px;
    width: 100%;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};

    div {
        transform: scale(1.2);
    }
`